import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="page policy">
      <h1>Privacy Policy</h1>
      <p>Last updated: March 24, 2026</p>

      <section>
        <h2>1. Introduction</h2>
        <p>
          Welcome to CarEx Marketplace, a product of <strong>Inspire The Next Inc.</strong>{' '}
          We respect your privacy and are committed to protecting your personal data. This
          privacy policy explains how we look after your personal data when you visit our
          website or use our mobile application and describes your privacy rights.
        </p>
      </section>

      <section>
        <h2>2. Data We Collect</h2>
        <p>We may collect, use, store and transfer different kinds of personal data about you which we have grouped together follows:</p>
        <ul>
          <li>Identity Data: includes first name, maiden name, last name, username or similar identifier.</li>
          <li>Contact Data: includes billing address, delivery address, email address and telephone numbers.</li>
          <li>Transaction Data: includes details about payments to and from you and other details of products and services you have purchased from us.</li>
        </ul>
      </section>

      <section>
        <h2>3. How We Use Your Data</h2>
        <p>We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:</p>
        <ul>
          <li>Where we need to perform the contract we are about to enter into or have entered into with you.</li>
          <li>Where it is necessary for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests.</li>
        </ul>
      </section>

      <section>
        <h2>4. Contact Us</h2>
        <p>
          Questions about this privacy policy:{' '}
          <a href="mailto:privacy@carexmarket.com">privacy@carexmarket.com</a>. General
          customer service: see our <Link to="/support">Support</Link> page for{' '}
          <a href="mailto:support@carexmarket.com">support@carexmarket.com</a> and phone
          contact.
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;

